import React from 'react'

const chunkReloadStorageKey = 'skolanalys:chunk-reload-attempted-at'
const chunkReloadWindowMs = 60000

function getErrorText(error: unknown) {
  if (error instanceof Error) {
    return `${error.name} ${error.message}`
  }

  return String(error)
}

function isChunkLoadError(error: unknown) {
  const errorText = getErrorText(error)

  return (
    errorText.includes('ChunkLoadError') ||
    errorText.includes('Loading chunk') ||
    errorText.includes('Failed to fetch dynamically imported module') ||
    errorText.includes("Unexpected token '<'")
  )
}

function shouldReloadForChunkError() {
  try {
    const previousReload = Number(
      window.sessionStorage.getItem(chunkReloadStorageKey)
    )
    const now = Date.now()

    if (previousReload && now - previousReload < chunkReloadWindowMs) {
      return false
    }

    window.sessionStorage.setItem(chunkReloadStorageKey, String(now))
    return true
  } catch {
    return true
  }
}

export default class ChunkLoadErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    if (isChunkLoadError(error) && shouldReloadForChunkError()) {
      window.location.reload()
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || 'Loading...'
    }

    return this.props.children
  }
}
